import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sortByLocale } from '@nimbus-library/features/localization/utils/active-locale';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { IOptionItem } from '@nimbus-library/features/shared/models/interfaces/i-option-item';
import { ApiRoutes } from '@nimbus-admin/routing/api-routes.const';

interface TenantSearchItem {
  id: string;
  name: string;
  domain?: string;
}

@Injectable({ providedIn: 'root' })
export class OperationsServicesLookupService {
  public constructor(private readonly httpService: BaseHttpService) {}

  public fetchTenants(): Observable<IOptionItem[]> {
    return this.httpService.get(ApiRoutes.CustomerHistory.FetchOperationsServicesTenants()).pipe(
      map((items: TenantSearchItem[]) =>
        sortByLocale(items ?? [], (x): string => x.name || x.domain).map((x) => ({
          id: x.id,
          name: x.name || x.domain,
        })),
      ),
    );
  }

  public fetchServices(tenantId: string): Observable<IOptionItem[]> {
    return this.httpService
      .get(ApiRoutes.CustomerHistory.FetchOperationsServices(tenantId))
      .pipe(map((items: TenantSearchItem[]) => sortByLocale(items ?? [], (x): string => x.name).map((x) => ({ id: x.id, name: x.name }))));
  }
}
